import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { ShiftDataService } from '../shift-data.service';
import { DashboardService } from '../../../services/dashboard.service';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'app/shared/alert/alert.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import configurationData from 'assets/configuration.json';
@Component({
    selector: 'app-assets-filter-dialog',
    templateUrl: './assets-filter-dialog.component.html',
    styleUrls: ['./assets-filter-dialog.component.scss'],
})
export class AssetsFilterDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public selectedAssetType: any;
    filtersCopy: any[] = [];

    public filters: any[] = [];
    public isDay: boolean = false;
    public isNight: boolean = false;
    public isMaster: boolean = false;
    public issueTypeData: any[] = [];
    public issueTypeDataCopy: any[] = [];
    public isWorkorder: boolean = false;
    public displayDayNightToggle: boolean = false;
    public displayIssueType: boolean = false;
    loggedInUser: any;
    summaryData: any;
    selectedIssueTypeCount: string = 'Select Issue Type';
    constructor(
        public shiftDataService: ShiftDataService,
        public dashboardService: DashboardService,
        private alertService: AlertService,
        private router: Router,
        private route: ActivatedRoute,
        public dialogRef: MatDialogRef<AssetsFilterDialogComponent>
    ) { }

    ngOnInit(): void {

        let currentPage = localStorage.getItem('currentPage');
        this.isWorkorder = currentPage === 'WorkOrder' ? true : false;
        this.loggedInUser = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')) : undefined;
        //configuration files,
        this.displayDayNightToggle = configurationData.displayDayNightToggle[this.loggedInUser.org_id.toString()] === undefined ?
            configurationData.displayDayNightToggle['default'] : configurationData.displayDayNightToggle[this.loggedInUser.org_id.toString()];
        this.displayIssueType = configurationData.displayIssueType[this.loggedInUser.org_id.toString()] === undefined ?
            configurationData.displayIssueType['default'] : configurationData.displayIssueType[this.loggedInUser.org_id.toString()];

        if (currentPage === "MasterDataLibrary") this.displayIssueType = false;

        let ranges = localStorage.getItem('selectedIssueType')
        if (ranges && ranges != null && ranges != undefined && ranges != '' && ranges.length > 0) {
            this.selectedIssueTypeCount = JSON.parse(ranges);
            this.shiftDataService.selectIssueType = JSON.parse(ranges);
        }
        else {
            this.selectedIssueTypeCount = 'Select Issue Type';
            this.shiftDataService.selectIssueType = [];
        }
        if (this.shiftDataService.filtersIsFromMaster) {
            this.getMasterDataSummary();
            this.isMaster = true;
        } else if (currentPage != 'WorkOrder') {
            this.getShiftDataSummary();
            this.getIssueTypeData();
            this.isMaster = false;
        }
        else if (currentPage === 'WorkOrder') {
            this.getWorkOrderFilter();
            this.getIssueTypeData();
            this.isMaster = false;
        }
        this.route.queryParams.subscribe((params: any) => {
            if (params['selectedAssetIdsForFilter']) {
                this.shiftDataService.selectedAssetIdsForFilter = JSON.parse(
                    params['selectedAssetIdsForFilter']
                );
            } else {
                this.shiftDataService.selectedAssetIdsForFilter = [];
            }
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onSearchFilter(value: any) {
        this.selectedAssetType = undefined;

        if (value) {
            this.filters = [
                ...this.filtersCopy.filter((assetType) =>
                    assetType.asset_type_name.toLowerCase().includes(value.toLowerCase()) ||
                        assetType.assets.findIndex((asset) =>
                            asset.asset_name
                                .replace('_', ' ')
                                .toLowerCase()
                                .includes(value.toLowerCase())
                        ) > -1
                        ? assetType
                        : null
                ),
            ];
            // this.filters.map(filter => filter.assets.map(asset => asset.asset_name.replace("_", ' ').toLowerCase().includes(value.toLowerCase())));
            this.filters.forEach((filter) => {
                let filterCopyList = this.filtersCopy.filter(
                    // (data) => data.asset_type_id === filter.asset_type_id
                    (data) => data.asset_type_name === filter.asset_type_name
                );
                if (filterCopyList && filterCopyList.length) {
                    let filterCopy = filterCopyList[0];
                }
            });
            this.issueTypeData = [...this.issueTypeDataCopy.filter(
                (issueType: string) => issueType.toLowerCase().includes(value.toLowerCase())
            )]

            if (this.filters && this.filters.length) {
                this.selectedAssetType = this.filters[0];
            }
        } else {
            this.filters = [...this.filtersCopy];
            this.issueTypeData = [...this.issueTypeDataCopy];
            this.selectedAssetType = this.filters[0];
        }
    }

    onSelectFilterChange(event: any, asset: any) {
        if (event.checked) {
            this.filters.forEach((data: any) => {
                if (data.asset_type_id === asset.asset_type_id) {
                    data.selected_asset_count++;
                }
            })
        }
        else {
            this.filters.forEach((data: any) => {
                if (data.asset_type_id === asset.asset_type_id && data.selected_asset_count > 0) {
                    data.selected_asset_count--;
                }
            })
        }
        this.shiftDataService.selectedAssetIdsForFilter =
            this.shiftDataService.selectedAssetIdsForFilter.filter(
                (a) => +a.asset_id == +asset.asset_id
            ).length > 0
                ? this.shiftDataService.selectedAssetIdsForFilter.filter(
                    (a) => +a.asset_id != +asset.asset_id
                )
                : [...this.shiftDataService.selectedAssetIdsForFilter, asset];
    }

    isChecked(asset: any) {
        return !!this.shiftDataService.selectedAssetIdsForFilter.filter(
            (a) => a.asset_id == asset.asset_id
        ).length;
    }

    onAssetClick(assetType: any) {
        this.selectedAssetType = assetType;
    }

    private getShiftDataSummary() {
        let chainageRange: any = [];
        let ranges: any = localStorage.getItem('selectedChainageRanges');
        if (ranges && (ranges != '' || ranges != null || ranges != undefined)) {
            let selectedChainageRanges = JSON.parse(ranges);
            if (selectedChainageRanges && selectedChainageRanges != null && selectedChainageRanges != undefined && selectedChainageRanges != '') {
                selectedChainageRanges.forEach((value) => {
                    chainageRange.push(value.chainage);
                })
            }
        }
        let isShiftMCW = this.checkLocalStorage("isShiftMCW");
        let isShiftServiceLanes = this.checkLocalStorage("isShiftServiceLanes");
        const serviceLane = (isShiftMCW && isShiftServiceLanes) ? null : isShiftServiceLanes ? 'SERVICE_LANE' : isShiftMCW ? 'MCW' : null;
        let isShiftDataShoulder = this.checkLocalStorage("isShiftDataShoulder");
        let isShiftDataMedian = this.checkLocalStorage("isShiftDataMedian");
        const isShoulderMedian = (isShiftDataShoulder && isShiftDataMedian) ? '' : isShiftDataShoulder ? 'shoulder' : 'median';
        if (this.shiftDataService && this.shiftDataService.selectedSubSite && this.shiftDataService.selectedSubSite.length > 1) {
            this.shiftDataService.selectedSubSite.site_id = [];
            this.shiftDataService.selectedSubSite.forEach((selectedSite) => {
                this.shiftDataService.selectedSubSite.site_id.push(selectedSite.site_id);
            })
        }
        let search: any = { site_ids: this.shiftDataService.selectedSubSite.site_id };
        let isNight = this.checkLocalStorage('isNight');
        let isDay = this.checkLocalStorage('isDay');
        let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
        let currentPage = localStorage.getItem('currentPage');
        // isDayNight = currentPage === 'WorkOrder' ? 'both' : isDayNight;
        localStorage.setItem("ServiceLaneMCW", serviceLane);
        let selectIssueType = currentPage === 'ShiftDataAnalysis' ? [] : this.shiftDataService.selectIssueType;
        // this.dashboardService.clearAllCache().subscribe(
        //     (res: any) => {  
        //         if(res.responseStatus.statusCode === 200){
        let selectedFilter: any = localStorage.getItem('selectedFilter');
        if (selectedFilter && selectedFilter != null && selectedFilter != undefined && selectedFilter != '') {
            selectedFilter = JSON.parse(selectedFilter);
            if (selectedFilter?.periodFrom != null) {
                search.periodFrom = selectedFilter.periodFrom;
            }
            if (selectedFilter?.minChainageValue != null) {
                search.minChainageValue = selectedFilter.minChainageValue;
            }
            if (selectedFilter?.periodTo != null) {
                search.periodTo = selectedFilter.periodTo;
            }
            if (selectedFilter?.maxChainageValue != null) {
                search.maxChainageValue = selectedFilter.maxChainageValue;
            }
        }
        const anomalyStatusStr = localStorage.getItem('anomalyStatus');
        if (!anomalyStatusStr) {
            search.anomalyStatus = [];
        }
        else {
            search.anomalyStatus = JSON.parse(anomalyStatusStr);
        }
        this.dashboardService.getShiftDataSummary(search, isShoulderMedian, isDayNight, this.shiftDataService.selectIssueType, serviceLane, this.shiftDataService.isUnique).subscribe(
            (res: any) => {
                let summaryData = res.responseData[0].records;
                if (summaryData) {
                    summaryData.forEach((asset_type: any) => {
                        asset_type.assets.forEach((asset: any) => {
                            asset.asset_type_id = (asset_type.asset_type_id)
                        })
                        asset_type.selected_asset_count = 0;
                    })
                }
                this.shiftDataService.sortAssetsAscendingOrder(summaryData);
                this.filters = summaryData;
                this.selectedAssetType = this.filters[0];
                this.filtersCopy = [...this.filters];
                this.dayNightState();
            },
            (error) => {
                // this.alertService.error(error.responseStatus.statusDescription);
            }
        );
        // }});
    }

    checkLocalStorage(value: string) {
        if (localStorage.getItem(value) !== null) {
            return localStorage.getItem(value) === "true" ? true : false;
        }
        else {
            return true;
        }
    }

    private getMasterDataSummary() {
        let chainageRange: any = [];
        let ranges: any = localStorage.getItem('selectedChainageRanges');
        if (ranges && (ranges != '' || ranges != null || ranges != undefined)) {
            let selectedChainageRanges = JSON.parse(ranges);
            if (selectedChainageRanges && selectedChainageRanges != null && selectedChainageRanges != undefined && selectedChainageRanges != '') {
                selectedChainageRanges.forEach((value) => {
                    chainageRange.push(value.chainage);
                })
            }
        }
        let isMasterMCW = this.checkLocalStorage("isMasterMCW");
        let isMasterServiceLanes = this.checkLocalStorage("isMasterServiceLanes");
        const serviceLane = (isMasterMCW && isMasterServiceLanes) ? null : isMasterServiceLanes ? 'SERVICE_LANE' : isMasterMCW ? 'MCW' : null;
        localStorage.setItem("ServiceLaneMCW", serviceLane);
        let isMasterDataShoulder = this.checkLocalStorage("isMasterDataShoulder");
        let isMasterDataMedian = this.checkLocalStorage("isMasterDataMedian");
        const isShoulderMedian = (isMasterDataShoulder && isMasterDataMedian) ? '' : isMasterDataShoulder ? 'shoulder' : 'median';
        if (this.shiftDataService && this.shiftDataService.selectedSubSite && this.shiftDataService.selectedSubSite.length > 1) {
            this.shiftDataService.selectedSubSite.site_id = [];
            this.shiftDataService.selectedSubSite.forEach((selectedSite) => {
                this.shiftDataService.selectedSubSite.site_id.push(selectedSite.site_id);
            })
        }
        let search = { site_ids: this.shiftDataService.selectedSubSite.site_id };
        // this.dashboardService.clearAllCache().subscribe(
        //     (res: any) => {  
        //         if(res.responseStatus.statusCode === 200){
        this.dashboardService.getMasterDataSummary(search, isShoulderMedian, serviceLane, chainageRange).subscribe(
            (res: any) => {
                let summaryData = [];
                if (res.responseData[0] && res.responseData[0].records && res.responseData[0].records.length > 0) {
                    this.shiftDataService.sortAssetsAscendingOrder(res.responseData[0].records);
                    res.responseData[0].records.forEach((asset) => {
                        if (asset.assets.length > 0) {
                            summaryData.push(asset);
                        }
                    })
                }
                // this.shiftDataService.filters = summaryData;
                //sort assets/sitename (filter) in ascending order
                this.shiftDataService.sortAssetsAscendingOrder(summaryData);
                this.filters = summaryData;

                this.selectedAssetType = this.filters[0];
                this.filtersCopy = [...this.filters];
                // this.setFalseTrueTogglePos();
            },
            (error) => {
                // this.alertService.error(error.responseStatus.statusDescription);
            }
        );
        // }});
    }

    onAssetTypeClick(assetType, checked, skipEmit = false) {
        if (checked) {
            this.filters.forEach((data: any) => {
                if (data.asset_type_id === assetType.asset_type_id) {
                    data.selected_asset_count = assetType.assets.length;
                }
            })
        }
        else {
            this.filters.forEach((data: any) => {
                if (data.asset_type_id === assetType.asset_type_id && data.selected_asset_count > 0) {
                    data.selected_asset_count = 0;
                }
            })
        }
        this.filters.filter((at) => at.asset_type_name == assetType.asset_type_name)[0]
            .assets.forEach((asset) => {
                this.shiftDataService.selectedAssetIdsForFilter = !checked
                    ? this.shiftDataService.selectedAssetIdsForFilter.filter(
                        (a) => +a.asset_id != +asset.asset_id
                    )
                    : [
                        ...this.shiftDataService.selectedAssetIdsForFilter,
                        asset,
                    ];
            });
        if (!skipEmit) {
            this.onAssetClick(assetType);
            // this.shiftDataService.onFilterChange.emit(
            //     this.shiftDataService.selectedAssetIdsForFilter
            // );
            // this.applyAssetFilters(this.shiftDataService.selectedAssetIdsForFilter);
        }
    }
    onSelectAllAssetTypesClick(checked) {
        if (checked) {
            this.filters.forEach((data: any) => {
                data.selected_asset_count = data.assets.length;
            })
        }
        else {
            this.filters.forEach((data: any) => {
                data.selected_asset_count = 0;
            })
        }
        this.filters.forEach((at) => {
            this.onAssetTypeClick(at, checked, true);
        });
        // this.shiftDataService.onFilterChange.emit(
        //     this.shiftDataService.selectedAssetIdsForFilter
        // );
    }
    isAssetTypeChecked(assetType) {
        let selectedAssets = [];
        let selected_assets_count: number = 0;
        assetType.assets.forEach((asset) => {
            if (
                this.shiftDataService.selectedAssetIdsForFilter.filter(
                    (a) => +a.asset_id == +asset.asset_id
                ).length
            ) {
                selectedAssets.push(asset);
                selected_assets_count++;
            }
        });
        assetType.selected_asset_count = selected_assets_count;
        // console.log(`${assetType.asset_type_name} ${ assetType.assets.length == selectedAssets.length }`)
        return assetType.assets.length == selectedAssets.length ? true : false;
    }
    onSelectAllAssetsClick(checked) {
        this.onAssetTypeClick(this.selectedAssetType, checked, false);
    }

    onSubmitClick() {
        localStorage.setItem('ShiftDataSummaryAnomalies', JSON.stringify(this.summaryData));
        localStorage.setItem('isNight', this.isNight.toString());
        localStorage.setItem('isDay', this.isDay.toString());
        localStorage.setItem('selectedIssueType', JSON.stringify(this.shiftDataService.selectIssueType));
        // <!-- assets/anomaly should be clickable in Anomaly/Master -->
        this.shiftDataService.assetFilterByClickingOnAnomaly = this.shiftDataService.assetFilterByClickingOnAnomaly === true ? false : false;
        localStorage.setItem("assetFilterByClickingOnAnomaly", this.shiftDataService.assetFilterByClickingOnAnomaly.toString());
        this.shiftDataService.assetFilterByClickingOnAsset = this.shiftDataService.assetFilterByClickingOnAsset === true ? false : false;
        localStorage.setItem("assetFilterByClickingOnAsset", this.shiftDataService.assetFilterByClickingOnAsset.toString());
        this.shiftDataService.applyAssetFilters(
            this.shiftDataService.selectedAssetIdsForFilter, this.shiftDataService.selectIssueType
        );
        // if(this.shiftDataService && this.shiftDataService.selectedAssetIdsForFilter && this.shiftDataService.selectedAssetIdsForFilter.length > 0){
        // }
        this.dialogRef.close();
    }

    onDayClick() {
        let centerBgId: string = '';
        let currentPage = localStorage.getItem('currentPage');
        centerBgId = currentPage === 'WorkOrder' ? 'centerbg-110' : 'centerbg-10';
        this.shiftDataService.selectIssueType = [];
        this.shiftDataService.selectedAssetIdsForFilter = [];
        this.isDay = true;
        this.isNight = false;
        localStorage.setItem('isDay', this.isDay.toString());
        localStorage.setItem('isNight', this.isNight.toString());
        let d = document.getElementById(centerBgId);
        d.classList.remove('center-bg-median', 'center-bg');
        document.getElementById(centerBgId).classList.add('center-bg-shoulder');
        this.getWorkOrderFilter();
    }

    onDayAndNightClick() {
        let centerBgId: string = '';
        let currentPage = localStorage.getItem('currentPage');
        centerBgId = currentPage === 'WorkOrder' ? 'centerbg-110' : 'centerbg-10';
        this.shiftDataService.selectIssueType = [];
        this.shiftDataService.selectedAssetIdsForFilter = [];
        this.isDay = true;
        this.isNight = true;
        localStorage.setItem('isDay', this.isDay.toString());
        localStorage.setItem('isNight', this.isNight.toString());
        let d = document.getElementById(centerBgId);
        d.classList.remove('center-bg-shoulder', 'center-bg-median');
        document.getElementById(centerBgId).classList.add('center-bg');
        this.getWorkOrderFilter();
    }

    onNightClick() {
        let centerBgId: string = '';
        let currentPage = localStorage.getItem('currentPage');
        centerBgId = currentPage === 'WorkOrder' ? 'centerbg-110' : 'centerbg-10';
        this.shiftDataService.selectIssueType = [];
        this.shiftDataService.selectedAssetIdsForFilter = [];
        this.isNight = true;
        this.isDay = false;
        localStorage.setItem('isNight', this.isNight.toString());
        localStorage.setItem('isDay', this.isDay.toString());
        let d = document.getElementById(centerBgId);
        d.classList.remove('center-bg-shoulder', 'center-bg');
        document.getElementById(centerBgId).classList.add('center-bg-median');
        this.getWorkOrderFilter();
    }

    dayNightState() {
        let centerBgId: string = '';
        let currentPage = localStorage.getItem('currentPage');
        centerBgId = currentPage === 'WorkOrder' ? 'centerbg-110' : 'centerbg-10';
        // this.shiftDataService.selectIssueType = [];
        // this.shiftDataService.selectedAssetIdsForFilter = [];
        let isNight = this.checkLocalStorage('isNight');
        this.isNight = isNight;
        let isDay = this.checkLocalStorage('isDay');
        this.isDay = isDay;
        let d = document.getElementById(centerBgId);
        if (isNight && isDay) {
            d.classList.remove('center-bg-shoulder', 'center-bg-median');
            document.getElementById(centerBgId).classList.add('center-bg');
        }
        else if (isNight) {
            d.classList.remove('center-bg-shoulder', 'center-bg', 'center-bg-median');
            document.getElementById(centerBgId).classList.add('center-bg-median');
        }
        else if (isDay) {
            d.classList.remove('center-bg-median', 'center-bg');
            document.getElementById(centerBgId).classList.add('center-bg-shoulder');
        }
    }

    private getIssueTypeData() {
        let site_id: any = [];
        if (this.shiftDataService && this.shiftDataService.selectedSubSite[0] && this.shiftDataService.selectedSubSite[0].site_id) {
            site_id.push(this.shiftDataService.selectedSubSite[0].site_id);
        }
        else if (this.shiftDataService && this.shiftDataService.selectedSubSite && this.shiftDataService.selectedSubSite.site_id) {
            site_id.push(this.shiftDataService.selectedSubSite.site_id);
        }
        this.dashboardService.getIssueTypeData(site_id).subscribe(
            (res: any) => {
                this.issueTypeData = res;
                this.issueTypeDataCopy = [...res];
                this.issueTypeData.forEach((type) => {
                    if (type) {
                        this.isCheckedIssueType(type);
                    }
                })
            },
            (error) => {
                // this.alertService.error(error.responseStatus.statusDescription);
            }
        );
    }

    isCheckedIssueType(issueType: any) {
        if (this.shiftDataService.selectIssueType && this.shiftDataService.selectIssueType.length > 0) {
            return this.shiftDataService.selectIssueType.filter((a) => a == issueType).length > 0;
        }
        let ranges = localStorage.getItem('selectedIssueType')
        if (ranges && ranges != null && ranges != undefined && ranges != '') {
            let selectIssueType = JSON.parse(ranges);
            if (selectIssueType) {
                return (selectIssueType.filter((a) => a == issueType)).length > 0 ? true : false;
            }
        }
        return false;
    }

    isFilterEnabled() {
        return (this.shiftDataService.selectedAssetIdsForFilter.length > 0) ? true : false;
    }

    onIssueTypeClick(issueType: any) {
        this.shiftDataService.selectIssueType =
            this.shiftDataService && this.shiftDataService.selectIssueType && this.shiftDataService.selectIssueType.filter(
                (a) => a == issueType).length > 0 ? this.shiftDataService.selectIssueType.filter((a) => a != issueType)
                : [...this.shiftDataService.selectIssueType, issueType];
        this.selectedIssueTypeCount = this.shiftDataService.selectIssueType;
        this.getWorkOrderFilter();
    }

    onSelectAllIssueTypesClick(checked: boolean) {
        if (checked) {
            this.shiftDataService.selectIssueType = [...this.issueTypeData];
        } else {
            this.shiftDataService.selectIssueType = [];
        }
        this.selectedIssueTypeCount = this.shiftDataService.selectIssueType;
    }

    displayAssetTypeName(asset_type_name: any) {
        asset_type_name = asset_type_name.replace('_', ' ');
        return asset_type_name.replace('ASSETS', 'INVENTORY');
    }

    private getWorkOrderFilter() {
        let search: any = {
            site_ids: '',
            page: 0,
            size: 20,
            anomaly_type: 'Anomaly',
            verification_type: '',
            chainage: undefined,
            issueType: undefined,
            detectionStatus: [],
            closureType: [],
            UIType: [],
        };
        let manualSelected: boolean = false;
        let aiRejectedSelected: boolean = false;
        let detectedSelected: boolean = false;
        let resolvedSelected: boolean = false;
        let autoClosedSelected: boolean = false;

        search.periodFrom = null;
        search.periodTo = null;
        search.minChainageValue = null;
        search.maxChainageValue = null;
        /**verification filter changes */
        search.verification_type = null;
        /*WO anomaly and completed filter changes */
        search.detectionStatus = [];
        search.closureType = [];
        /*section changes */
        //this.search.section = null;
        setTimeout(() => {
            const queryParams = this.route.snapshot.queryParams;
            if (queryParams.filterStartDate && queryParams.filterEndDate) {
                search.periodFrom = queryParams.filterStartDate;
                search.periodTo = queryParams.filterEndDate;
            }
            if (queryParams.chainageLowValue) {
                search.minChainageValue = queryParams.chainageLowValue;
                search.maxChainageValue = queryParams.chainageHighValue;
            }
            /*WO anomaly and completed filter changes */
            let selectedTabIndex: number = 0;
            let currentWorkOrderTab: any = localStorage.getItem('currentWorkOrderTab');
            if (currentWorkOrderTab == "Manual_Closure") {
                selectedTabIndex = 5;
                search.anomaly_type = "Manual_Closure";
            }
            else if (currentWorkOrderTab == "Ignored") {
                selectedTabIndex = 2;
                search.anomaly_type = "Ignored";
            }
            else if (currentWorkOrderTab == "Completed") {
                selectedTabIndex = 3;
                search.anomaly_type = "Completed";
            }
            else if (currentWorkOrderTab == "Deleted") {
                selectedTabIndex = 4;
                search.anomaly_type = "Deleted";
            }
            else if (currentWorkOrderTab == "Under_Inspection") {
                selectedTabIndex = 5;
                search.anomaly_type = "Under_Inspection";
            }
            else {
                selectedTabIndex = 0;
                search.anomaly_type = "Anomaly";
            }
            if (queryParams.detectionStatus && selectedTabIndex == 0) {
                search.detectionStatus = JSON.parse(
                    queryParams.detectionStatus
                );
            }
            if (queryParams.closureType && selectedTabIndex == 3) {
                search.closureType = JSON.parse(
                    queryParams.closureType
                );
            }
            search.site_ids =
                this.shiftDataService.selectedMasterSite.sub_sites
                    .map((site) => site.site_id)
                    .toString();
            let chainageRange: any = [];
            let ranges: any = localStorage.getItem('selectedChainageRanges');
            if (ranges && (ranges != '' || ranges != null || ranges != undefined)) {
                let selectedChainageRanges = JSON.parse(ranges);
                if (selectedChainageRanges && selectedChainageRanges != null && selectedChainageRanges != undefined && selectedChainageRanges != '') {
                    selectedChainageRanges.forEach((value) => {
                        chainageRange.push(value.chainage);
                    })
                }
            }
            let isNight = this.checkLocalStorage('isNight');
            let isDay = this.checkLocalStorage('isDay');
            let isDayNight = (isDay && isNight) ? 'both' : isNight ? 'Night' : isDay ? 'Day' : '';
            search.verification_type = search.anomaly_type === "Completed" ? this.shiftDataService.verification_type : '';
            let closureType: any = localStorage.getItem("closureType");
            if (closureType != null && closureType != undefined && closureType != '' && closureType != 'null') {
                this.shiftDataService.closureType = JSON.parse(closureType);
                if (this.shiftDataService.closureType && this.shiftDataService.closureType.length > 0 && selectedTabIndex == 3) {
                    search.closureType = this.shiftDataService.closureType;
                    resolvedSelected = false;
                    autoClosedSelected = false;
                    this.shiftDataService.closureType.forEach((ds: any) => {
                        if (ds === 'resolvedSelected') {
                            resolvedSelected = true;
                        }
                        if (ds === 'autoClosedSelected') {
                            autoClosedSelected = true;
                        }
                    });
                }
            }
            let UIType: any = localStorage.getItem("UIType");
            if (UIType != null && UIType != undefined && UIType != '' && UIType != 'null') {
                this.shiftDataService.UIType = JSON.parse(UIType);
                if (this.shiftDataService.UIType && this.shiftDataService.UIType.length > 0 && selectedTabIndex == 5) {
                    search.UIType = this.shiftDataService.UIType;
                }
            }
            this.dashboardService.getWorkOrderFilter(search, chainageRange, isDayNight, this.shiftDataService.selectIssueType).subscribe(
                (res: any) => {
                    // this.getIssueTypeData();
                    let summaryData = res.responseData[0].records;
                    if (summaryData) {
                        summaryData.forEach((asset_type: any) => {
                            asset_type.assets.forEach((asset: any) => {
                                asset.asset_type_id = (asset_type.asset_type_id)
                            })
                            asset_type.selected_asset_count = 0;
                        })
                    }
                    this.shiftDataService.sortAssetsAscendingOrder(summaryData);
                    this.filters = summaryData;
                    this.selectedAssetType = this.filters[0];
                    this.filtersCopy = [...this.filters];
                    this.dayNightState();
                },
                (error) => {
                    // this.alertService.error(error.responseStatus.statusDescription);
                }
            );
        });
    }
}
